export default "__VITE_ASSET__DI8EXe2N__"